import Vue from "vue";
import Router from "vue-router";
const Page = () => import("@/view/indexPage.vue");
const Index = () => import("@/view/index.vue");
const about = () => import("@/view/about.vue");
const Indexrem = () => import("@/view/rem/index.vue");
const aboutrem = () => import("@/view/rem/about.vue");
const settlepro = () => import("@/view/Settle/index.vue");
const Settle = () => import("@/view/Settle/Settle.vue");
const regist = () => import("@/view/Settle/regist.vue");
const gologin = () => import("@/view/Settle/gologin.vue");
const OneOutOfThree = () => import("@/view/Settle/OneOutOfThree.vue");
const Information = () => import("@/view/Settle/Information.vue");
const OAIndex = () => import("@/view/OAIndex.vue");

Vue.use(Router);

const routes = [{
    path: "/",
    redirect: `${document.body.clientWidth < 750 ? '/Page/Indexrem' : '/Page/Index'}`
},
{
    path: "/Page",
    name: "Page",
    redirect: `${document.body.clientWidth < 750 ? '/Page/Indexrem' : '/Page/Index'}`,
    component: Page,
    children: [{
        path: "Index",
        name: "Index",
        component: Index
    },
    {
        path: "about",
        name: "about",
        component: about
    },
    {
        path: "OAIndex",
        name: "OAIndex",
        component: OAIndex,

    },
    {
        path: "Indexrem",
        name: "Indexrem",
        component: Indexrem
    },
    {
        path: "aboutrem",
        name: "aboutrem",
        component: aboutrem
    },
    {
        path: "settlepro",
        name: "settlepro",
        component: settlepro
    },
    {
        path: "settlepro/Settle",
        name: "Settle",
        component: Settle,
        meta: {
            title: "商家入驻",
            isAuth: false
        }
    },
    {
        path: "settlepro/regist",
        name: "regist",
        component: regist,
        meta: {
            title: "商家入驻",
            isAuth: false
        }
    },
    {
        path: "settlepro/OneOutOfThree",
        name: "regist",
        component: OneOutOfThree,
        meta: {
            title: "商家入驻",
            isAuth: false
        }
    },
    {
        path: "settlepro/Information",
        name: "regist",
        component: Information,
        meta: {
            title: "商家入驻",
            isAuth: false
        }
    },
    {
        path: "settlepro/gologin",
        name: "gologin",
        component: gologin,
        meta: {
            title: "商家入驻",
            isAuth: false
        }
    },

    ]
}
];
const router = new Router({
    mode: "history",
    routes,
    scrollBehavior(to, from, savedPosition) {
        // console.log(savedPosition)
        if (savedPosition) {
            return savedPosition;
        } else {
            return {
                x: 0,
                y: 0
            };
        }
    }
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js